import { FC } from "react";

type IProps = {
  width?: string;
  height?: string;
};

const MasterCard: FC<IProps> = ({ width = "48", height = "30" }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 48 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M30.3902 3.46912H17.5758V26.5309H30.3902V3.46912Z"
        fill="#FF5F00"
      />
      <path
        d="M18.3895 15C18.3875 12.779 18.89 10.5866 19.8591 8.58887C20.8282 6.59112 22.2384 4.84035 23.983 3.46911C21.8226 1.76844 19.228 0.710828 16.4957 0.417139C13.7635 0.123451 11.0038 0.605531 8.53222 1.8083C6.06062 3.01107 3.97677 4.88599 2.51887 7.21876C1.06097 9.55152 0.287842 12.248 0.287842 15C0.287842 17.752 1.06097 20.4485 2.51887 22.7813C3.97677 25.114 6.06062 26.989 8.53222 28.1917C11.0038 29.3945 13.7635 29.8766 16.4957 29.5829C19.228 29.2892 21.8226 28.2316 23.983 26.5309C22.2384 25.1597 20.8282 23.4089 19.8591 21.4111C18.8901 19.4134 18.3875 17.221 18.3895 15Z"
        fill="#EB001B"
      />
      <path
        d="M47.6775 15C47.6776 17.752 46.9046 20.4485 45.4467 22.7812C43.9889 25.114 41.9051 26.9889 39.4336 28.1917C36.962 29.3945 34.2024 29.8766 31.4702 29.5829C28.738 29.2892 26.1434 28.2316 23.983 26.5309C25.7261 25.1583 27.1352 23.4072 28.1041 21.4098C29.0731 19.4124 29.5765 17.2207 29.5765 15C29.5765 12.7793 29.0731 10.5877 28.1041 8.59022C27.1352 6.59278 25.7261 4.84173 23.983 3.4691C26.1434 1.76844 28.738 0.71082 31.4702 0.417135C34.2024 0.123451 36.962 0.605552 39.4336 1.80833C41.9051 3.01111 43.9889 4.88604 45.4467 7.21881C46.9046 9.55157 47.6776 12.248 47.6775 15Z"
        fill="#F79E1B"
      />
      <path
        d="M46.2802 24.0883V23.6162H46.4703V23.52H45.9862V23.6162H46.1764V24.0883H46.2802ZM47.2202 24.0883V23.519H47.0718L46.9011 23.9106L46.7303 23.519H46.5819V24.0883H46.6866V23.6589L46.8467 24.0291H46.9554L47.1155 23.658V24.0883H47.2202Z"
        fill="#F79E1B"
      />
    </svg>
  );
};

export default MasterCard;
